// extracted by mini-css-extract-plugin
module.exports = {"buttonBox":"ButtonBox_buttonBox__uN02K","messageBox":"ButtonBox_messageBox__qWjng","icon":"ButtonBox_icon__y6bmI","text":"ButtonBox_text__ET4yG"};